/*
 * @Author: ziyongqiang
 * @Descripttion:
 * @Date: 2023-05-23 10:10:29
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-30 09:43:06
 * @FilePath: \product_air2.0\src\pages\logged\pages\account\accountReq.ts
 */

import { getRequest, post, postRequest, } from '@/request/request';

// 查询账号列表
export const getAccountList = (params:any) => postRequest('/openUser/queryPage', params);

// 查询账号区域
export const queryAccountRegion = (accountType: any,isOpen?: any) => {
  if (isOpen || isOpen === 0) {
    return postRequest(`/openUser/queryUserRegion?isOpen=${isOpen}&accountType=${accountType}`);
  }

  return postRequest(`/openUser/queryUserRegion?accountType=${accountType}`);
};

// 注册账号
export const registerTrialUser = (params:any) => postRequest('/openUser/registerTrialUser', params);

// 权限全量菜单
export const getRightLists = () :any => getRequest('/menu/menuAllList');

// 修改账号
export const updateUser = (params:any) => postRequest('/openUser/updateUser', params);

// 更新权限
export const updateRight = (params:any) :any => postRequest('/role/grant',params);

// 开通或拒绝试用账号
export const openOrRefuseTrialUser = (params:any) => postRequest('/openUser/openOrRefuseTrialUser', params);

// 撤回已拒绝账户
export const revokeUser = (id:string) :any => postRequest(`/openUser/revokeUser?id=${id}`);

// 项目账号查询
export const trackUsers = (regionId:string,userName:string,openType:string) :any => postRequest(`/openUser/trackUsers?regionId=${regionId}&userName=${userName}&openType=${openType}`);

// 状态开关更新
export const updateStatus = (params:any) :any => postRequest('/openUser/openOrCloseUser',params);

// 查询所有部门树状图列表
export const selectTreeList = () :any => postRequest(`/openUser/selectTreeList`);

// 开启或关闭账号
export const openOrCloseUser = (params:any) => postRequest('/openUser/openOrCloseUser', params);
